// extracted by mini-css-extract-plugin
export default {"map-container":"Inspect_map-container__dnIgZ"};